(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["elm-bundler-volume"] && !Shopify.designMode) return;
  try {
    const applyElmBundlerVolume = () => {
      const copy = document.querySelector('.elm-bundler-copy');
      if (!copy) return;

      document.querySelectorAll('.bndlr-volume[data-bundle-name="Volume discount"]').forEach((widget) => {
        widget.classList.add('elm-bundler-volume');

        const title = widget.querySelector('.bndlr-volume-title');
        const description = widget.querySelector('.bndlr-volume-description');
        const tier = widget.querySelector('.bndlr-volume-main-text');
        const savings = widget.querySelector('.bndlr-volume-saving-text');

        if (title) title.textContent = copy.dataset.title;
        if (description) description.textContent = copy.dataset.description;
        if (tier) tier.textContent = copy.dataset.tier;
        if (savings) savings.textContent = copy.dataset.savings;
      });
    };

    applyElmBundlerVolume();

    const elmBundlerObserver = new MutationObserver(applyElmBundlerVolume);
    elmBundlerObserver.observe(document.body, { childList: true, subtree: true });
  } catch(e) { console.error(e); }
})();

})();
